import { Vehicle, Camera, ViewMode } from './';
export const SET_VEHICLES = 'SET_VEHICLES';
export const TOGGLE_CAMERA = 'TOGGLE_CAMERA';
export const SEARCH = 'SEARCH';
export const CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE';
export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE';

export interface SetVehicles {
  type: typeof SET_VEHICLES,
  payload: {
    vehicles: Vehicle[],
    cameras: Camera[]
  }
}

export interface ToggleCamera {
  type: typeof TOGGLE_CAMERA,
  payload: {
    toggleTo: boolean,
    camera: Camera
  }
}

export interface Search {
  type: typeof SEARCH,
  payload: {
    searchValue: string
  }
}

export interface ChangeViewMode {
  type: typeof CHANGE_VIEW_MODE,
  payload: {
    viewMode: ViewMode
  }
}

export interface ToggleCollapse {
  type: typeof TOGGLE_COLLAPSE,
  payload: {
    leftPanelCollapsed: boolean
  }
}

export type AppActionTypes = SetVehicles | ToggleCamera | Search | ChangeViewMode | ToggleCollapse;